import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=c21c35ca&scoped=true"
import script from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=c21c35ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c35ca",
  null
  
)

export default component.exports